jQuery(function ($) {
    initMobileMenu();
    slickPostsGrid();
    bookMixedContentTabs();
    orderInBulk();


    function initMobileMenu() {
        $('.mobile-nav-menu .menu-item-has-children').append('<span class="submenu-toggle"></span>');
        $('.mobile-nav-hamburger').on('click', function () {
            $('body, html').toggleClass('body-is-mobile');
            $('.mobile-nav-background').toggleClass('is-mobile');
            $('.mobile-nav-hamburger').toggleClass('mobile-burger');
            $('.burger').toggleClass('burger-x');
            $('.mobile-nav-menu-links').toggleClass('mobile-links-visible');
        });

        $('.mobile-nav-menu .menu-item-has-children > .submenu-toggle').on('click', function (e) {
            e.preventDefault();
            $('.mobile-nav-menu .menu-item-has-children').not($(this).parent()).removeClass('mobile-show-submenu');
            $(this).parent().toggleClass('mobile-show-submenu');
        });
    }

    function slickPostsGrid() {
        $('.slick-posts .fl-post-grid').slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: true,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        variableWidth: true
                    }
                }
            ]
        });


        $('.slick-posts .fl-post-grid.no-features').slick('unslick');
    }

    function bookMixedContentTabs() {
        $('#book-detail-tabs li a:not(#2)').addClass('inactive');
        $('#book-detail-tabs li:not(.tab-item_2)').addClass('no-border');
        $('.book-panels-container .panel').hide();
        $('.book-panels-container #p-2').show();
        $('.book-panels-container #p-2 .panel-wrap').show();
            
        $('#book-detail-tabs li a').click(function(){
            var tab = $(this).attr('id');
        
            if ($(this).hasClass('inactive')) { 
                $('#book-detail-tabs li a').addClass('inactive');  
                $('#book-detail-tabs li').addClass('no-border');  
                $(this).parent().removeClass('no-border');         
                $(this).removeClass('inactive');
                
                $('.book-panels-container .panel').hide();
                $('.book-panels-container #p-'+ tab).fadeIn('slow');
                $('.book-panels-container #p-'+ tab + ' .panel-wrap').show();
            }
        });
    }

    function orderInBulk() {
        // For Watch Listen Template page Video Lightbox Popup
        $('.order-bulk.fl-button-lightbox').magnificPopup({
            type: 'inline',
            preloader: false,
            focus: '#name',
            
            callbacks: {
                beforeOpen: function() {
                    if($(window).width() < 700) {
                        this.st.focus = false;
                    } else {
                        this.st.focus = '#name';
                    }
                }
            }
        });
    }
});
